export const COMPLIANCE_COLORS = {
  green: {
    text: '#008000',
    background: '#D9ECD9',
    border: '#008000',
  },
  red: {
    text: '#C81212',
    background: '#FCE8E6',
    border: '#C81212',
  },
  gray: {
    text: '#CDCDCD',
    background: '#F7F7F7',
    border: '#CDCDCD',
  },
  yellow: {
    text: '#FFA500',
    background: '#FFF4E6',
    border: '#FFA500',
  },
};
